import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Title } from "~/components/ui";

export const ReferenceDocumentsHeader: FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Title level={5} className="p-4 pb-3">
      {t("referenceDocs:title")}
    </Title>
  );
};
